import * as React from 'react';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import HyperlinkContainer from './HyperlinkContainer';

const Hyperlink = props => {
  const { element, elementStyle } = props;
  const { formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <HyperlinkContainer element={element} {...props} className={className} />
    </FormItem>
  );
};

export default Hyperlink;
